import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export function PasswordInput({ testId, className = "", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={`pr-11 ${className}`} data-testid={testId} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        className="absolute inset-y-0 right-0 w-11 flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
        data-testid={`${testId}-toggle`}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}

const RULES = [["10 caractères minimum", (p) => p.length >= 10], ["Une minuscule", (p) => /[a-z]/.test(p)], ["Une majuscule", (p) => /[A-Z]/.test(p)],
  ["Un chiffre", (p) => /\d/.test(p)], ["Un caractère spécial", (p) => /[^A-Za-z0-9]/.test(p)]];
export const strongEnough = (p) => RULES.every(([, fn]) => fn(p || ""));

export function StrengthRules({ value }) {
  return (
    <ul className="grid grid-cols-2 gap-x-3 gap-y-0.5 text-[11px] mt-1.5" data-testid="password-rules">
      {RULES.map(([l, fn]) => <li key={l} className={fn(value || "") ? "text-emerald-700" : "text-muted-foreground"}>{fn(value || "") ? "✓" : "•"} {l}</li>)}
    </ul>
  );
}
